export interface TrackChangesVisibilityState {
  masterVisible: boolean;
  insertionsVisible: boolean;
  deletionsVisible: boolean;
  formattingVisible: boolean;
}
